import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import PortfolioProjectsContainer from '../../../containers/portfolio/PortfolioProjectsContainer.jsx';

const PortfolioProjects = ({ portfolioId, slug }) => (
  <>
    <Helmet>
      <title>{getOrgTermsContent('portfolio')} | ChangeSync</title>
    </Helmet>
    <PortfolioProjectsContainer portfolioId={portfolioId} slug={slug} />
  </>
);

PortfolioProjects.getInitialProps = ({ query }) => ({
  portfolioId: Number(query.portfolioId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(PortfolioProjects));
